export { default } from './UserViewWardrobeItems'
